import PropTypes from 'prop-types';
import React from 'react';

import {tags as definedTags} from '!json-loader!yaml-loader!../../data/tags.yaml';

import Tag from './Tag';

export default class TagList extends React.Component {
	static propTypes = {
		tags: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
	}

	static defaultProps = {
		tags: [],
	}

	render() {
		const {
			tags,
		} = this.props;

		if (tags.length === 0) {
			return null;
		}

		return (
			<ul className="tag-list">
				{tags.map(tag =>
					<React.Fragment key={tag.label}>
						<li className="tag-list__item">
							<Tag {...tag} />
						</li>
						{" "}
					</React.Fragment>
				)}
			</ul>
		);
	}
}

export class TagListFromStrings extends React.Component  {
	static propTypes = {
		tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	}

	static defaultProps = {
		tags: [],
	}

	render() {
		const {
			tags,
		} = this.props;

		if (tags.length === 0) {
			return null;
		}

		const fullTags = tags.map(tag => definedTags[tag]);

		return <TagList tags={fullTags} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/TagList.js